import React from 'react'
import { Box, Container, Grid, Typography } from '@material-ui/core'

import Link from '../Link'
import SocialIcons from '../SocialIcons'

import RichText from '../RichText'
import { useStyles } from './Footer.styles'
import FooterForm from '../FooterForm/FooterForm'
import { isObjectEmpty } from '../../utils/objects'
import { replaceBucketUrl } from '../../utils/cms'
import AppDownloadLink from '../AppDownloadLink/AppDownloadLink'

const Footer = React.forwardRef(({ t, data = {}, path, pageContext }, ref) => {
  const {
    allRightsReserved,
    navigationLinks = [],
    companyInfo = {},
    waitingList,
    socialLinks = [],
    footerLinks = [],
    downloadAppUrls,
  } = data

  const {
    downloadAppstoreUrl,
    downloadPlaystoreUrl,
    downloadAppGalleryUrl,
  } = downloadAppUrls

  const companyInformation = companyInfo.raw && JSON.parse(companyInfo.raw)
  const styles = useStyles()

  return (
    <footer id="footer-main" className={styles.footerContainer}>
      {!isObjectEmpty(waitingList) && (
        <FooterForm
          waitingList={waitingList}
          path={path}
          ref={ref}
          pageContext={pageContext}
          t={t}
        />
      )}

      {/* Footer with page links and social icons and licencing information and all rights resercved text */}
      <Box bgcolor="footer.background" color="footer.text">
        <Container maxWidth="lg">
          <Grid container columns={2} className={styles.footerWrapper}>
            <Box className={styles.links} color="footer.text">
              {navigationLinks.map((route) => (
                <Link
                  key={`nav-link-${route?.title.split(' ').join('-')}`}
                  id={`nav-link-${route?.title.split(' ').join('-')}`}
                  to={route?.link || '/'}
                >
                  {route?.title}
                </Link>
              ))}
            </Box>
            <Box className={styles.iconLinks}>
              <SocialIcons socialLinks={socialLinks} />
              {(downloadAppstoreUrl ||
                downloadPlaystoreUrl ||
                downloadAppGalleryUrl) && (
                <Box className={styles.downloadLinks}>
                  {downloadAppstoreUrl && (
                    <AppDownloadLink link={downloadAppstoreUrl} />
                  )}
                  {downloadPlaystoreUrl && (
                    <AppDownloadLink link={downloadPlaystoreUrl} />
                  )}
                  {downloadAppGalleryUrl && (
                    <AppDownloadLink link={downloadAppGalleryUrl} />
                  )}
                </Box>
              )}
            </Box>
          </Grid>

          {companyInformation && (
            <RichText
              className={styles.bsfInfo}
              document={companyInformation}
            />
          )}
          <Box className={styles.footerLinksWrapper}>
            <Typography variant="body2" className={styles.copyright}>
              {allRightsReserved}
            </Typography>
            <Box className={styles.footerLinks}>
              {footerLinks.map((route) => (
                <Link
                  key={`footer-link-${route.title}`}
                  id={`footer-link-${route.title}`}
                  to={replaceBucketUrl(route?.link || '/')}
                  className={styles.copyright}
                  isExternal={route.isExternal}
                >
                  {route?.title}
                </Link>
              ))}
            </Box>
          </Box>
        </Container>
      </Box>
    </footer>
  )
})
Footer.displayName = 'Footer'

export default Footer
